import styled from 'styled-components';

export default styled.div`
  display: flex;
  margin: 3px 5px 3px 0;
`;
